(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  // set footer-height var in root
  const footr = document.querySelector('footer');
  if (footr) document.documentElement.style.setProperty('--footer-height', `${footr.offsetHeight}px`);

  // hide cookie settings footer menu item if privacy api not loaded
  document.addEventListener('DOMContentLoaded', () => {
    const menuEl = document
      .querySelector('footer')
      ?.querySelector('a[href$="#shopifyReshowConsentBanner"]')
      ?.closest('li');
    if (menuEl && !window.privacyBanner) {
      menuEl.classList.add('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-swiper"] && !Shopify.designMode) return;
  try {
    
  const sectionEl = document.querySelector('.gallery-swiper');
  if (sectionEl) {
    // swiper params
    const autoplay = sectionEl.hasAttribute('data-swiper-autoplay');
    const delay =
      autoplay && sectionEl.hasAttribute('data-swiper-delay') ? parseInt(sectionEl.dataset.swiperDelay) : 3000;
    const space = sectionEl.hasAttribute('data-swiper-spacing') ? parseInt(sectionEl.dataset.swiperSpacing) : 0;
    const spaceSp = sectionEl.hasAttribute('data-swiper-spacing') ? parseInt(sectionEl.dataset.swiperSpacing) * 0.5 : 0;

    // init swiper thumbs
    const thumbs = new Swiper(`.swiper-thumbs`, {
      speed: 300,
      slidesPerView: 4,
      spaceBetween: spaceSp,
      breakpoints: { 750: { spaceBetween: space } },
    });
    // init swiper
    const swiper = new Swiper(`.swiper-main`, {
      allowTouchMove: false,
      autoHeight: true,
      speed: 500,
      slidesPerView: 1,
      lazyPreloadPrevNext: 3,
      loop: true,
      navigation: {
        enabled: true,
        prevEl: '.gallery-swiper-prev',
        nextEl: '.gallery-swiper-next',
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: autoplay ? { delay: delay, pauseOnMouseEnter: true } : false,
      thumbs: {
        swiper: thumbs,
      },
      on: {
        init: function () {
          this.el.closest('.gallery-swiper').classList.remove('swiper-hide');
        },
        slideChangeTransitionStart: function () {
          if (window.scrollY > this.el.closest('.gallery-swiper').offsetTop)
            scrollTo({ top: this.el.closest('.gallery-swiper').offsetTop });
        },
      },
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-swiper"] && !Shopify.designMode) return;
  try {
    
  const sectionEl = document.querySelector('.index-swiper');
  if (sectionEl) {
    // swiper params
    const autoplay = sectionEl.hasAttribute('data-swiper-autoplay');
    const delay =
      autoplay && sectionEl.hasAttribute('data-swiper-delay')
        ? parseInt(sectionEl.getAttribute('data-swiper-delay'))
        : 3000;
    const swiperType = sectionEl.dataset.swiperType;
    const sped = swiperType == 'creative' ? 600 : 300;
    let spv = 'auto';
    if (swiperType == 'hero') spv = 1.1;
    if (swiperType == 'coverflow') spv = 1.3;
    const space = sectionEl.hasAttribute('data-swiper-spacing')
      ? parseInt(sectionEl.getAttribute('data-swiper-spacing'))
      : 0;
    const spaceSp = sectionEl.hasAttribute('data-swiper-spacing')
      ? parseInt(sectionEl.getAttribute('data-swiper-spacing')) * 0.5
      : 0;
    const breakpoint = sectionEl.hasAttribute('data-swiper-slide-width')
      ? parseInt(sectionEl.getAttribute('data-swiper-slide-width'))
      : 768;
    const creativeEf =
      swiperType == 'creative'
        ? {
            prev: {
              translate: ['-50%', 0, -1],
              opacity: 0,
            },
            next: {
              translate: ['100%', 0, 0],
            },
          }
        : {};
    const coverEf =
      swiperType == 'coverflow'
        ? {
            rotate: 0,
            stretch: 0,
            depth: 0,
            scale: 0.6,
            modifier: 0.3,
            slideShadows: false,
          }
        : {};

    // init swiper
    let indexSwiper = new Swiper(`.swiper-${sectionEl.dataset.id}`, {
      speed: sped,
      slidesPerView: spv,
      spaceBetween: spaceSp,
      centeredSlides: sectionEl.dataset.swiperType != 'creative',
      lazyPreloadPrevNext: 3,
      loop: true,
      autoplay: autoplay ? { delay: delay, pauseOnMouseEnter: true } : false,
      pagination: {
        el: `.pagination-${sectionEl.dataset.id}`,
        clickable: true,
      },
      effect: swiperType,
      creativeEffect: creativeEf,
      coverflowEffect: coverEf,
      breakpoints: {},
      on: {
        init: function () {
          if (swiperType == 'slide')
            this.params.breakpoints[breakpoint] = { slidesPerView: 'auto', spaceBetween: space };
          if (swiperType == 'coverflow') this.params.breakpoints[750] = { slidesPerView: 3.5 };
          sectionEl.classList.remove('swiper-hide');
        },
      },
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        indexSwiper = new Swiper(`.swiper-${sectionEl.dataset.id}`, {
          speed: sped,
          slidesPerView: spv,
          spaceBetween: spaceSp,
          centeredSlides: sectionEl.dataset.swiperType != 'creative',
          lazyPreloadPrevNext: 3,
          loop: true,
          autoplay: autoplay ? { delay: delay, pauseOnMouseEnter: true } : false,
          pagination: {
            el: `.pagination-${sectionEl.dataset.id}`,
            clickable: true,
          },
          effect: swiperType,
          creativeEffect: creativeEf,
          coverflowEffect: coverEf,
          breakpoints: {},
          on: {
            init: function () {
              if (swiperType == 'slide')
                this.params.breakpoints[breakpoint] = { slidesPerView: 'auto', spaceBetween: space };
              if (swiperType == 'coverflow') this.params.breakpoints[750] = { slidesPerView: 3.5 };
              document.querySelector('.index-swiper').classList.remove('swiper-hide');
            },
          },
        });
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inquiry-selector"] && !Shopify.designMode) return;
  try {
    
  const form = document.querySelectorAll('section')[1];
  const mailer = document.querySelector('.contact-mailer');
  const radios = document.querySelector('.contact-radios').querySelectorAll('input');
  if (radios && form && mailer) {
    form.classList.add('hidden');
    radios.forEach((element) => {
      element.addEventListener('change', (e) => {
        form.classList.toggle('hidden', e.target.value != 'personal');
        mailer.classList.toggle('hidden', e.target.value != 'business');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // audio samples TODO move to separate .js file
  const prodEl = document.querySelector('product-info');
  const samples = prodEl ? parseInt(prodEl.dataset.audio) : 0;
  const wrapper = prodEl?.querySelector('.audio-wrapper');

  if (prodEl && samples > 0 && wrapper) {
    const audioEl = wrapper.querySelector('.audio-sample');
    const elementsToToggle = wrapper.querySelectorAll('.audio-icon');

    // both play and pause svgs are present in DOM; this toggled both .hidden classes to switch their visibility
    function toggleHide() {
      if (elementsToToggle) {
        for (let i = 0; i < elementsToToggle.length; i++) {
          elementsToToggle[i].classList.toggle('hidden');
        }
      }
    }

    // plays and pauses audio depending on audio state, also toggles play/pause graphic
    function playAudio() {
      if (audioEl) {
        toggleHide();
        if (audioEl.paused) {
          audioEl.play();
        } else {
          audioEl.pause();
        }
      }
    }

    // toggles play to pause when playback ends
    if (audioEl) {
      audioEl.addEventListener('ended', (event) => {
        toggleHide();
      });
    }

    // play button listener
    wrapper.querySelector('button')?.addEventListener('click', () => {
      playAudio();
    });

    // loads new audio on variant switch if multiple samples are present
    if (!prodEl.hasAttribute('data-audio-single') && audioEl) {
      function loadAudio() {
        if (!audioEl.paused) {
          toggleHide();
          audioEl.pause();
        }
        audioEl.load();
      }

      const observer = new MutationObserver(loadAudio);
      observer.observe(wrapper, {
        subtree: true,
        childList: true,
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  const contactTags = document.getElementById('contact-tags');
  const contactTagsElements = document.querySelectorAll('.contact-tags-element');

  const setContactTags = () => {
    let tagsText = '';
    contactTagsElements.forEach((element) => {
      if (element.type === 'radio' && element.checked) {
        if (tagsText === '') {
          tagsText = element.value;
        } else {
          tagsText += ',' + element.value;
        }
      } else if (element.type !== 'radio' && element.value) {
        if (tagsText === '') {
          tagsText = element.value;
        } else {
          tagsText += ',' + element.value;
        }
      }
    });
    contactTags.value = tagsText;
  };

  // https://stackoverflow.com/a/1184359
  // set form day options
  const dobYear = document.getElementById('RegisterForm-BirthYear');
  const dobMonth = document.getElementById('RegisterForm-BirthMonth');
  const dobDay = document.getElementById('RegisterForm-BirthDay');
  const dobReq = dobYear?.hasAttribute('required');
  //選択クリア
  const clearEl = document.getElementById('RadioClear');
  const genderReq = document.querySelector('input[value="gen:M"]')?.hasAttribute('required');

  function getDays(y, m) {
    return new Date(parseInt(y), parseInt(m), 0).getDate();
  }
  const setDays = () => {
    let maxDays = getDays(dobYear.value.slice(5), dobMonth.value.slice(5));
    let selectedDay = parseInt(dobDay.value.slice(5));
    let dayContent = dobReq ? '' : '<option value=""></option>';
    if (maxDays) {
      for (let i = 1; i <= maxDays; i++) {
        if (selectedDay && selectedDay <= maxDays && selectedDay == i) {
          dayContent += `
            <option value="dob3-${i}" selected>${i}</option>
          `;
        } else {
          dayContent += `
            <option value="dob3-${i}">${i}</option>
          `;
        }
      }
    } else {
      return;
    }
    dobDay.innerHTML = dayContent;
  };
  document.addEventListener('DOMContentLoaded', () => {
    [dobYear, dobMonth].forEach((select) => {
      select.addEventListener('change', setDays);
    });
    contactTagsElements.forEach((element) => {
      element.addEventListener('change', setContactTags);
    });
    if (!genderReq && clearEl) {
      clearEl.addEventListener('click', (event) => {
        event.preventDefault();
        let checkedEl = document.querySelector('input[name="customer[gender]"]:checked');
        if (checkedEl) {
          checkedEl.checked = false;
          if (contactTags.value != '' && contactTags.value.includes('gen')) {
            // gender index will always be 0 if present
            let tagArr = contactTags.value.split(',');
            if (tagArr) {
              tagArr.splice(0, 1);
              contactTags.value = tagArr.join();
            }
          }
        } else {
          return;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["profile"] && !Shopify.designMode) return;
  try {
    
  const dataEl = document.querySelector('.profile');
  if (dataEl) {
    const pSwiper = new Swiper(`.swiper-${dataEl.dataset.id}`, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      pagination: true,
      navigation: {
        enabled: true,
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      on: {
        init: function () {
          this.el.closest('.profile').classList.remove('profile-hide');
        },
      },
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-swiper"] && !Shopify.designMode) return;
  try {
    
  const sectionEl = document.querySelector('.video-swiper');

  if (sectionEl) {
    const vswiper = new Swiper(`.swiper-${sectionEl.dataset.id}`, {
      spaceBetween: 8,
      loop: true,
      navigation: {
        prevEl: `.swiper-buttons-${sectionEl.dataset.id} .slider-button--prev`,
        nextEl: `.swiper-buttons-${sectionEl.dataset.id} .slider-button--next`,
      },
      pagination: {
        el: `.swiper-buttons-${sectionEl.dataset.id} .slider-counter`,
        type: 'bullets',
        clickable: true,
      },
      on: {
        init: function () {
          sectionEl.classList.remove('swiper-hide');
        },
        slideChange: function () {
          window.pauseAllMedia();
        },
      },
    });
  }

  } catch(e) { console.error(e); }
})();
})();
